import loglevel from 'loglevel';
import { isLogRocketEnabled } from '@/utils/logrocket.utils';

import { ConfigStore } from '@sureinc/atlas-common/config';

const envLogLevel = import.meta.env.VITE_LOG_LEVEL;

loglevel.setDefaultLevel(
  envLogLevel
    ? envLogLevel
    : ConfigStore.config.environment === 'production'
      ? loglevel.levels.WARN
      : loglevel.levels.DEBUG
);

const originalFactory = loglevel.methodFactory;
loglevel.methodFactory = function (methodName, logLevel, loggerName) {
  const rawMethod = originalFactory(methodName, logLevel, loggerName);

  return function (...message) {
    if (isLogRocketEnabled) {
      import('logrocket').then(({ default: LogRocket }) => {
        LogRocket[methodName === 'trace' ? 'track' : methodName](
          message.join(' ')
        );
      });
    }
    rawMethod(...message);
  };
};

loglevel.rebuild();

export default loglevel;
